(()=>{
'use strict';
class RoutineCommerce {
  constructor(manifest,config={}) { this.manifest=manifest;this.root=(config.root||'/').replace(/\/?$/,'/');this.currency=config.currency||'USD';this.marker='sfsc-guided-routine'; }
  async request(path,body) {
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),20000);
    try {
      const response=await fetch(this.root+path,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{}),signal:controller.signal});
      const data=await response.json().catch(()=>null);
      if(!response.ok)throw new Error(data?.description||data?.message||'The store could not update your cart. Please try again.');
      if(!data)throw new Error('The store returned an incomplete response. Please try again.');
      return data;
    } finally { clearTimeout(timer); }
  }
  planMonths(plan) {
    if(!plan.recurring_deliveries)return null;
    const option=plan.options?.find(o=>o.name==='Order Frequency and Unit');
    const match=String(option?.value||plan.name).match(/(?:^|\b)([1-3])(?:-|\s+)months?\b/i);
    return match?Number(match[1]):null;
  }
  async loadCatalog() {
    const entries=await Promise.all(Object.entries(this.manifest).map(async([key,definition])=>{
      const product=await this.request('products/'+encodeURIComponent(definition.handle)+'.js');
      const plans=new Map();
      for(const group of product.selling_plan_groups||[])for(const plan of group.selling_plans||[]){const months=this.planMonths(plan);if(months)plans.set(Number(plan.id),{id:Number(plan.id),months,name:plan.name});}
      const variants=definition.variants.map(choice=>{
        const live=product.variants.find(v=>Number(v.id)===choice.id);
        if(!live)return {...choice,available:false,missing:true,regular:0,sub:null,plans:{},image:null};
        const allocations={};
        for(const allocation of live.selling_plan_allocations||[]){const plan=plans.get(Number(allocation.selling_plan_id));if(plan&&!allocations[plan.months])allocations[plan.months]={...plan,price:allocation.price};}
        const preferred=allocations[2]||allocations[3]||allocations[1];
        const image=live.featured_image?.src||product.featured_image;
        return {...choice,available:live.available===true,regular:live.price,sub:preferred?.price??null,plans:allocations,image:image?String(image).replace(/^\/\//,'https://'):null};
      });
      return [key,{...definition,variants,image:String(product.featured_image||'').replace(/^\/\//,'https://')}];
    }));
    return Object.fromEntries(entries);
  }
  buildItems(lines,catalog,cadence) {
    const grouped=new Map();
    if(!lines.length)throw new Error('Add a product to your basket first.');
    for(const line of lines){
      const product=catalog[line.key],variant=product?.variants[line.variant];
      if(!variant?.available)throw new Error((product?.name||'This product')+' is unavailable. Choose another pick or remove it.');
      if(!Number.isInteger(line.qty)||line.qty<1||line.qty>99)throw new Error('Check the quantity for '+product.name+'.');
      const plan=line.type==='sub'?variant.plans[cadence]:null;
      if(line.type==='sub'&&!plan)throw new Error(product.name+' does not support this refill schedule. Choose another schedule or buy it once.');
      const key=variant.id+':'+(plan?.id||'once');
      if(grouped.has(key))grouped.get(key).quantity+=line.qty;
      else grouped.set(key,{id:variant.id,quantity:line.qty,...(plan?{selling_plan:plan.id}:{}),properties:{_sfsc_routine:this.marker}});
      if(grouped.get(key).quantity>99)throw new Error('Choose no more than 99 of the same pick.');
    }
    return [...grouped.values()];
  }
  signature(item) {return Number(item.variant_id||item.id)+':'+(item.selling_plan_allocation?.selling_plan?.id||item.selling_plan||'once');}
  ours(item) {return item.properties?._sfsc_routine===this.marker;}
  async syncCart(items) {
    const wanted=new Map(items.map(item=>[this.signature(item),item]));
    let cart=await this.request('cart.js');
    const existingCurrency=cart.currency;
    if(existingCurrency&&existingCurrency!==this.currency)throw new Error('Your currency changed. Reload this page before checking out.');
    const maxChanges=cart.items.length+items.length+5;
    for(let attempt=0;attempt<maxChanges;attempt++){
      const seen=new Set();let change=null;
      for(const line of cart.items.filter(line=>this.ours(line))){
        const signature=this.signature(line),target=!seen.has(signature)&&wanted.has(signature)?wanted.get(signature).quantity:0;
        seen.add(signature);
        if(line.quantity!==target){change={id:line.key,quantity:target};break;}
      }
      if(!change)break;
      cart=await this.request('cart/change.js',change);
      if(attempt===maxChanges-1)throw new Error('We could not match the quantities in your cart. Please review your cart.');
    }
    cart=await this.request('cart.js');
    const present=new Set(cart.items.filter(line=>this.ours(line)&&line.quantity>0).map(line=>this.signature(line)));
    const missing=items.filter(item=>!present.has(this.signature(item)));
    if(missing.length)await this.request('cart/add.js',{items:missing});
    cart=await this.request('cart.js');
    const actual=new Map();
    for(const line of cart.items.filter(line=>this.ours(line))){const key=this.signature(line);actual.set(key,(actual.get(key)||0)+line.quantity);}
    if(actual.size!==wanted.size||items.some(item=>actual.get(this.signature(item))!==item.quantity))throw new Error('The available quantity changed. Review your cart before continuing.');
    return cart;
  }
}
window.SFSCRoutineCommerce=RoutineCommerce;
})();
